import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import Button from "../common/Button";

const Checkbox = ({ state, onClick }: { state: boolean; onClick: Function }) => {
  const [isActive, setIsActive] = useState(state);

  useEffect(() => {
    setIsActive(state);
  }, [state]);

  return (
    <div
      style={{
        ...styles.checkbox,
        backgroundColor: isActive ? "var(--orange)" : "transparent",
        borderColor: isActive ? "var(--black)" : "var(--light-grey)",
      }}
      onClick={() => {
        setIsActive(!isActive);
        onClick(!isActive);
      }}
    />
  );
};

const styles: Record<string, React.CSSProperties> = {
  checkbox: {
    width: "2rem",
    height: "2rem",
    cursor: "pointer",
    border: "3px solid",
    flexShrink: 0,
  },
};

export default Checkbox;
